import type { SystemTab, SystemPageMode } from '../types';

export const SYSTEM_SECTION_TITLES: Record<SystemTab, string> = {
	permissions: 'Gestão de Grupos de Permissões',
	hierarchies: 'Gestão de Hierarquias',
	plans: 'Gestão de Planos',
};

export const SYSTEM_SECTION_SUBTITLES: Record<SystemTab, string> = {
	permissions: 'Gerencie os grupos de permissões para serem usadas nas hierarquias do sistema',
	hierarchies: 'Gerencie as hierarquias para serem usadas nos planos do sistema',
	plans: 'Gerencie os planos para os usuários serem cadastrados no sistema',
};

export const SYSTEM_CTA_TITLES: Record<SystemTab, string> = {
	permissions: 'Adicione um grupo de permissões',
	hierarchies: 'Adicione uma hierarquia customizada',
	plans: 'Adicione um plano customizado',
};

export const SYSTEM_CTA_SUBTITLES: Record<SystemTab, string> = {
	permissions: 'Com esse grupo você poderá controlar o acesso dos usuários ao sistema',
	hierarchies: 'Com essa hierarquia você poderá controlar os planos do Practium',
	plans: 'Com esse plano você poderá controlar o acesso dos usuários ao Practium',
};

export const SYSTEM_PIE_TITLES: Record<SystemTab, string> = {
	permissions: 'Distribuição de Uso',
	hierarchies: 'Distribuição de Usuários',
	plans: 'Distribuição de Assinantes',
};

export const SYSTEM_PIE_SUBTITLES: Record<SystemTab, string> = {
	permissions: 'Distribuição do uso dos grupos nas hierarquias',
	hierarchies: 'Distribuição de usuários por nível hierárquico',
	plans: 'Distribuição de assinantes por plano',
};

export const SYSTEM_TITLES: Record<SystemTab, Record<SystemPageMode, string>> = {
	permissions: {
		add: 'Novo Grupo de Permissões',
		edit: 'Editar Grupo de Permissões',
		view: 'Informações do Grupo de Permissões',
	},
	hierarchies: {
		add: 'Nova Hierarquia',
		edit: 'Editar Hierarquia',
		view: 'Informações da Hierarquia',
	},
	plans: {
		add: 'Novo Plano',
		edit: 'Editar Plano',
		view: 'Informações do Plano',
	},
};

export const SYSTEM_SUBTITLES: Record<SystemPageMode, Record<SystemTab, string>> = {
	add: {
		permissions: 'Cadastre os dados gerais do novo grupo de permissões',
		hierarchies: 'Cadastre os dados gerais do nova hierarquia',
		plans: 'Cadastre os dados gerais do novo plano',
	},
	edit: {
		permissions: 'Edite os dados gerais do grupo de permissões',
		hierarchies: 'Edite os dados gerais da hierarquia',
		plans: 'Edite os dados gerais do plano',
	},
	view: {
		permissions: 'Visualize os dados gerais do grupo de permissões',
		hierarchies: 'Visualize os dados gerais da hierarquia',
		plans: 'Visualize os dados gerais do plano',
	},
};
